import Head from "next/head"
import React from "react"
import styled, { css } from "styled-components"

import Link from "~/components/atoms/Link"
import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Label from "~/components/atoms/Tag"
import Typography from "~/components/atoms/Typography"
import { Container } from "~/components/layouts/Container"
import Breadcrumb from "~/components/organisms/Breadcrumb"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import { Color, TextSize, IsPC, IsMobile, RadiusSize, Transition, LineHeight } from "~/consts/style-mixins"
import TabBar from "~/observers/TabBar"
import { internalLink, staticPath } from "~/services/helper"

interface StyledProps {
  bgSrc?: string
}

export default class Courses extends React.Component {
  render() {
    const crumbs = [
      {
        name: "スキルアップ講座一覧",
        link: internalLink(`/courses`),
      },
    ]

    return (
      <>
        <Head>
          <title>スキルアップ講座一覧 | Infra（インフラ）</title>
          <meta name="description" content="講座一覧です。" />
          <meta name="og:title" content="スキルアップ講座一覧 | Infra（インフラ）" />
          <meta name="og:description" content="講座一覧です。" />
          <meta property="og:image" content={`${process.env.APP_HOST + staticPath("/static/images/ogp.png")}`} />
        </Head>
        <Header showTab logoType="Courses" />
        <Container size="Large">
          <StyledInner>
            <Pc>
              <StyledTypography type="SubHero">
                <h1>スキルアップ講座一覧</h1>
              </StyledTypography>
            </Pc>
            <Sp>
              <StyledTypography type="SubHero">
                <h1>スキルアップ講座一覧</h1>
              </StyledTypography>
            </Sp>
            <StyledRecruitmentNum>全4件の講座</StyledRecruitmentNum>
            <StyledListItemsWrapper>
              <StyledRecruitmentCardWrapper>
                <StyledRecruitmentLinkArea>
                  <Link href={internalLink("/courses/data-science")}>
                    <StyledThumbnailImage
                      bgSrc={staticPath("/static/images/course/thumbnail/data-science.png")}
                      className="recruitment-img"
                    />
                    {/* <StyledLabel size="Medium" color={Color.Attention}>
                      募集終了
                    </StyledLabel> */}
                    <StyledTitle type="SubHeading">データサイエンス講座</StyledTitle>
                    <StyledDescription>
                      Pythonを用いながら、統計学や機械学習、さらには深層学習までを体系的に学び、初心者からデータサイエンス職へのエントリーレベルを目指します
                    </StyledDescription>
                  </Link>
                </StyledRecruitmentLinkArea>
              </StyledRecruitmentCardWrapper>
              <StyledRecruitmentCardWrapper>
                <StyledRecruitmentLinkArea>
                  <Link href={internalLink("/courses/web-programming")}>
                    <StyledThumbnailImage
                      bgSrc={staticPath("/static/images/course/thumbnail/web-programming.png")}
                      className="recruitment-img"
                    />
                    <StyledLabel size="Medium" color={Color.Attention}>
                      募集終了
                    </StyledLabel>
                    <StyledTitle type="SubHeading">Webプログラミング講座</StyledTitle>
                    <StyledDescription>
                      初心者でも３ヶ月で実務レベルに。就活のポートフォリオとしても使えるオリジナルアプリも作成できます。就職に繋がるプログラミング講座で即戦力エンジニアになろう！
                    </StyledDescription>
                  </Link>
                </StyledRecruitmentLinkArea>
              </StyledRecruitmentCardWrapper>
              <StyledRecruitmentCardWrapper>
                <StyledRecruitmentLinkArea>
                  <Link href={internalLink("/courses/writing")}>
                    <StyledThumbnailImage
                      bgSrc={staticPath("/static/images/course/thumbnail/writing.png")}
                      className="recruitment-img"
                    />
                    <StyledLabel size="Medium" color={Color.Attention}>
                      募集終了
                    </StyledLabel>
                    <StyledTitle type="SubHeading">ライティング講座</StyledTitle>
                    <StyledDescription>
                      対話で思考を紐解くインタビューの技術から、読み手の心を動かす執筆の技術まで。仕事に、自己表現に、考えの整理に応用できる「書く」スキルを学びます
                    </StyledDescription>
                  </Link>
                </StyledRecruitmentLinkArea>
              </StyledRecruitmentCardWrapper>
              <StyledRecruitmentCardWrapper>
                <StyledRecruitmentLinkArea>
                  <Link href={internalLink("/courses/marketing")}>
                    <StyledThumbnailImage
                      bgSrc={staticPath("/static/images/course/thumbnail/marketing.png")}
                      className="recruitment-img"
                    />
                    <StyledLabel size="Medium" color={Color.Attention}>
                      募集終了
                    </StyledLabel>
                    <StyledTitle type="SubHeading">マーケティング講座</StyledTitle>
                    <StyledDescription>
                      ITを駆使したデジタルマーケティングを体系的に学びます。講座の後半では実際に企業の課題に対して改善提案や広告プランニングを行い実務レベルを目指します
                    </StyledDescription>
                  </Link>
                </StyledRecruitmentLinkArea>
              </StyledRecruitmentCardWrapper>
              <StyledRecruitmentCardWrapper>
                <StyledRecruitmentLinkArea>
                  <Link href={internalLink("/courses/sales")}>
                    <StyledThumbnailImage
                      bgSrc={staticPath("/static/images/course/thumbnail/sales.png")}
                      className="recruitment-img"
                    />
                    <StyledLabel size="Medium" color={Color.Attention}>
                      募集終了
                    </StyledLabel>
                    <StyledTitle type="Heading">営業講座</StyledTitle>
                    <StyledDescription>
                      営業の基礎知識から現場で活用できる営業プロセスまで、未経験からプロのセールススキルを身につけることの出来るオンライン型集中プログラムです
                    </StyledDescription>
                  </Link>
                </StyledRecruitmentLinkArea>
              </StyledRecruitmentCardWrapper>
            </StyledListItemsWrapper>
          </StyledInner>
        </Container>
        <Breadcrumb crumbs={crumbs} />
        <Sp>
          <TabBar selectedTabIndex={0} />
        </Sp>
        <Footer />
      </>
    )
  }
}

const StyledTypography = styled(Typography)`
  margin-bottom: 8px;
`

const StyledInner = styled.div`
  ${IsPC(css`
    padding: 48px 0 24px;
    min-height: calc(100vh - 243px);
  `)}
  ${IsMobile(css`
    padding: 24px 0 8px;
    min-height: calc(100vh - 358px);
  `)}
`

const StyledRecruitmentNum = styled.div`
  margin-bottom: 24px;
  font-size: ${TextSize.S}px;
  color: ${Color.LightGray};
`

const StyledListItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${IsPC(css`
    margin: 0 -8px;
  `)}
`

const StyledRecruitmentCardWrapper = styled.div`
  width: 100%;
  margin-bottom: 24px;
  ${IsPC(css`
    width: 33.3%;
    padding: 0 12px;
  `)}
`
const StyledRecruitmentLinkArea = styled.div`
  width: 100%;
  position: relative;
  &:hover {
    .recruitment-img {
      border: solid 1px ${Color.Primary};
    }
  }
`

const StyledThumbnailImage = styled.div`
  width: 100%;
  margin-bottom: 12.5px;
  padding-top: 50%;
  border-radius: ${RadiusSize.Medium}px;
  background-size: cover;
  background-position: center center;
  height: auto;
  border: solid 1px ${Color.BorderGray};
  ${Transition.Hover};
  ${({ bgSrc }: StyledProps) => css`
    background-image: url("${bgSrc}");
  `}
`

const StyledLabel = styled(Label)`
  width: 80px;
  position: absolute;
  top: 125px;
  left: 8px;
`

const StyledTitle = styled(Typography)`
  margin: 6px 0 8px;
  font-weight: bold;
  height: auto;
  max-height: 44px;
  overflow: hidden;
`

const StyledDescription = styled.p`
  color: ${Color.Gray};
  font-size: ${TextSize.XS}px;
  line-height: ${LineHeight.M}%;
`
